import { Model } from 'qn/data';
import { computed } from 'mobx';

@Model({
    modelName: 'ISV2',
    fields: {
        id: 'id',
        supSuperiorName: 'string',
        superiorName: 'string',
        key: 'string',
        loginId: 'string',
        name: 'string',
        status: 'string',
        mail: 'string',
        phone: 'string',
        agentCode: 'string',
        agencyName: 'string',
        createdDate: 'date',
    },
    idProperty: 'key',
})
class ISV2 {
    constructor(data) {
    }
}

export default ISV2;
